module.exports = __webpack_public_path__ + "static/media/MailIcon.77cc0a28.svg";